export default () => ({
    slider: null,
    next: null,
    previous: null,

    init() {
        this.slider = this.$root.querySelector('[data-slider]')
        this.next = this.$root.querySelector('[data-next]')
        this.previous = this.$root.querySelector('[data-previous]')

        const debouncedUpdateNavigationState = this.debounce(this.updateNavigationState, 20)

        this.slider.addEventListener('scroll', debouncedUpdateNavigationState.bind(this))
    },
    nextSlide() {
        const slide = this.slider.firstElementChild
        this.slide(slide.offsetWidth)
    },
    previousSlide() {
        const slide = this.slider.firstElementChild
        this.slide(-slide.offsetWidth)
    },
    slide(value) {
        this.slider.scrollBy({
            left: value,
            behavior: 'smooth'
        })
    },
    updateNavigationState() {
        const endOfSlider = (this.slider.scrollLeft + this.slider.clientWidth) >= this.slider.scrollWidth
        const startOfSlider = this.slider.scrollLeft <= 0

        this.next.disabled = endOfSlider
        this.previous.disabled = startOfSlider
    },
    debounce(callback, delay) {
        let timeoutId

        return function(...args) {
            clearTimeout(timeoutId)

            timeoutId = setTimeout(() => {
                callback.apply(this, args)
            }, delay)
        }
    }
})

